import http from "./http-common";

class ClinicalNotesService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => (key && payload[key] ? key + "=" + payload[key] : ""))
      .join("&");
  }
  getPatientClinicalNotes(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/clinicalNote/list/filter?${queryString}`);
  }
  saveClinicalNote(data) {
    return http.post(`/clinicalNote/save`, data);
  }
}

export default new ClinicalNotesService();
